"use client";

import React from "react";
import { CircleQuestionMark, Mail, Send, Loader, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
const faqs = [{
  question: "Wat zijn jullie openingstijden?",
  answer: "Wij zijn geopend van maandag tot en met vrijdag, van 09:00 tot 18:00 uur. In het weekend en op nationale feestdagen zijn wij gesloten."
}, {
  question: "Hoe kan ik een afspraak maken?",
  answer: "U kunt eenvoudig een afspraak maken via het contactformulier op deze pagina, of door ons telefonisch te bereiken tijdens onze openingstijden."
}, {
  question: "Wat zijn de kosten voor een consult?",
  answer: "De kosten variëren afhankelijk van uw specifieke wensen en de benodigde tijd. Neem gerust contact met ons op voor een vrijblijvende prijsopgave op maat."
}, {
  question: "Waar zijn jullie gevestigd?",
  answer: "Ons hoofdkantoor is centraal gevestigd en goed bereikbaar met zowel de auto als het openbaar vervoer. Er is voldoende parkeergelegenheid in de directe omgeving."
}, {
  question: "Hoe snel kan ik een reactie verwachten?",
  answer: "Wij streven ernaar om alle aanvragen via het contactformulier binnen 24 uur (op werkdagen) te beantwoorden."
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 px-6 text-center bg-secondary/5 border border-border rounded-lg h-full min-h-[400px]">
        <CircleCheck className="size-16 text-primary mb-6" />
        <h3 className="text-2xl font-default font-bold text-foreground mb-2">Bericht Verzonden</h3>
        <p className="text-muted-foreground font-sans mb-8 max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="rounded-sm">
          Nieuw bericht sturen
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField control={control} name="name" rules={{
        required: "Naam is verplicht",
        minLength: {
          value: 2,
          message: "Minimaal 2 karakters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-sans">Naam</FormLabel>
              <FormControl>
                <Input placeholder="Uw volledige naam" className="bg-secondary text-secondary-foreground border-border focus-visible:border-primary focus-visible:ring-primary rounded-sm placeholder:text-secondary-foreground/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-mailadres is verplicht",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Ongeldig e-mailadres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-sans">E-mailadres</FormLabel>
              <FormControl>
                <Input type="email" placeholder="uw@email.nl" className="bg-secondary text-secondary-foreground border-border focus-visible:border-primary focus-visible:ring-primary rounded-sm placeholder:text-secondary-foreground/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="subject" rules={{
      required: "Onderwerp is verplicht"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground font-sans">Onderwerp</FormLabel>
            <FormControl>
              <Input placeholder="Waar gaat uw vraag over?" className="bg-secondary text-secondary-foreground border-border focus-visible:border-primary focus-visible:ring-primary rounded-sm placeholder:text-secondary-foreground/50" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Bericht is verplicht",
      minLength: {
        value: 10,
        message: "Bericht moet minimaal 10 karakters bevatten"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground font-sans">Bericht</FormLabel>
            <FormControl>
              <Textarea placeholder="Typ hier uw vraag of opmerking..." className="min-h-[150px] bg-secondary text-secondary-foreground border-border focus-visible:border-primary focus-visible:ring-primary rounded-sm placeholder:text-secondary-foreground/50 resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-sm">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm h-12 text-base font-semibold mt-4">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Verzenden...
          </> : <>
            <Send className="mr-2 size-5" />
            Verstuur Bericht
          </>}
      </Button>
    </Form>;
}
export default function FaqContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}